import OfferInclusionsList from 'components/Common/Inclusions/OfferInclusionsList'
import Modal from 'LuxKit/Modal/Modal'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { getHotelOfferUrl } from 'lib/offer/offerPageURL'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import SearchTileStackInclusionsList from '../shared/SearchTileStackInclusionsList'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'
import useLoyaltyBenefitInclusions from 'loyalty/hooks/useLoyaltyBenefitInclusions'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  truncateAfter?: number
}

function BedbankLTSSearchTileFeatures(props: Props) {
  const intl = useIntl()
  const { offer, truncateAfter = 7 } = props
  const showModal = useContext(ModalContext)
  const loyaltyCount = useLoyaltyBenefitInclusions(offer).length
  const showLoyaltyInline = ((offer.inclusions?.length ?? 0) + loyaltyCount) <= truncateAfter

  const openAllInclusionsModal = useCallback(() => {
    showModal(<Modal
      title={offer.property.name}
      primaryActionTo={getHotelOfferUrl(offer.id, offer.type)}
      primaryActionText={intl.formatMessage({
        id: 'QsPqaJ_bhA8fRQ-l-niE',
        defaultMessage: 'View offer',
        description: 'CTA button in bedbank LTS inclusions modal to view the offer',
      })}
    >
      <Group direction="vertical" gap={4} noDisplayWhenEmpty>
        {!!offer.inclusions?.length && <OfferInclusionsList inclusions={offer.inclusions} />}
        <LoyaltyInclusions offer={offer} variant="offer-page" />
      </Group>
    </Modal>)
  }, [showModal, offer, intl])

  if (!offer.inclusions?.length) return null

  return (
    <Group direction="vertical" gap={4}>
      {!!offer.inclusions?.length && <SearchTileStackInclusionsList
        inclusions={offer.inclusions}
        truncateAfter={truncateAfter}
        additionalHiddenCount={showLoyaltyInline ? 0 : loyaltyCount}
        onShowMoreClick={openAllInclusionsModal}
      />}
      {showLoyaltyInline && <LoyaltyInclusions offer={offer} variant="search-tile" />}
    </Group>
  )
}

export default BedbankLTSSearchTileFeatures
